import { db } from "firebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useLayoutEffect, useState } from "react";
import { storeInfo, storeInfoConverter } from "types/firestoreTypes";
import DefaultTemplate from "components/templates/DefaultTemplate";

const Shop = () => {
    const shopName = new URL(window.location.href).searchParams.get("name");
    if (!shopName) {
        window.history.back();
    }
    const [shopData, setShopData] = useState<storeInfo>({} as storeInfo);
    const [isLoading, setIsLoading] = useState(true);

    useLayoutEffect(() => {
        (async () => {
            const q = query(
                collection(db, "store_info"),
                where("store_name", "==", shopName)
            ).withConverter(storeInfoConverter);
            const d = (await getDocs(q)).docs.map((v) => v.data())[0] as
                | storeInfo
                | undefined;
            if (!d) {
                window.history.back();
                return;
            }
            setShopData(d);
            setIsLoading(false);
        })();
    }, [shopName]);

    return (
        <DefaultTemplate>
            {isLoading ? (
                <h2>Now Loading...</h2>
            ) : (
                <div>
                    <div
                        style={{
                            display: "flex",
                            // margin: "0 auto 0 calc((100% - width) / 2)",
                        }}
                    >
                        <div style={{ width: "30%" }}>
                            <img
                                src={shopData.store_logo}
                                alt="logo"
                                style={{ width: "100%" }}
                            />
                        </div>
                        <div>
                            <h2>
                                {shopData.store_name}({shopData.floor}F)
                            </h2>
                            {shopData.is_sale ? (
                                <p
                                    style={{
                                        color: "#f00",
                                    }}
                                >
                                    セール中!
                                </p>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                    <p>{shopData.store_detail}</p>
                    {shopData.tag.map((t) => (
                        <span
                            key={t}
                            style={{ border: "solid 1px", margin: "0 2%" }}
                        >
                            &emsp;{t}&emsp;
                        </span>
                    ))}
                    <br />
                    <br />
                    <button
                        onClick={() => window.history.back()}
                        style={{ height: "2rem", margin: "3%" }}
                    >
                        戻る
                    </button>
                    {shopData.is_camera ? (
                        <button
                            onClick={() => {
                                window.location.href = `/congestion?shop_name=${shopData.store_name}`;
                            }}
                            style={{ height: "2rem", margin: "3%" }}
                        >
                            混雑状況確認
                        </button>
                    ) : (
                        <></>
                    )}
                    <button
                        onClick={() => {
                            window.location.href = `/map?goal=${shopData.store_name}&goal_floor=${shopData.floor}`;
                        }}
                        style={{ height: "2rem", margin: "3%" }}
                    >
                        Map
                    </button>
                </div>
            )}
        </DefaultTemplate>
    );
};

export default Shop;
